module.exports = __webpack_public_path__ + "img/feedback2-3.e6ab0e15.jpg";